import { baseRestApi } from "api/rest/baseRestApi";
import enhanceWithPagination from "utils/enhanceWithPagination";
import paramsToTuples from "utils/paramsToTuples";

import { QueryArgs, ResponseType } from "./types";

module.hot?.accept();

export const getBrokerSourcesApi = baseRestApi.enhanceEndpoints({ addTagTypes: ["BROKER_SOURCES"] }).injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (builder) => ({
    getBrokerSources: builder.query<ResponseType, QueryArgs>({
      query: ({ queryParams }) => ({
        url: `broker/shipments/sources`,
        method: "GET",
        params: paramsToTuples(queryParams),
      }),
      providesTags: ["BROKER_SOURCES"],
    }),
  }),
});

export const { useGetBrokerSourcesQuery, useLazyGetBrokerSourcesQuery } = enhanceWithPagination(
  getBrokerSourcesApi,
  "getBrokerSources",
  { take: 25 }
);
